import { render, staticRenderFns } from "./ThePopup.vue?vue&type=template&id=ba44e62a&scoped=true&"
import script from "./ThePopup.vue?vue&type=script&lang=js&"
export * from "./ThePopup.vue?vue&type=script&lang=js&"
import style0 from "./ThePopup.vue?vue&type=style&index=0&id=ba44e62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba44e62a",
  null
  
)

export default component.exports